import { getDoctors } from 'Redux/modules/doctor/actions';
import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

let axiosCancelToken = null;
const useGetDoctors = () => {
  const dispatch = useDispatch();

  const {
    doctors: { list, status, meta },
  } = useSelector(state => state);

  const getListDoctor = useCallback(
    params => {
      if (axiosCancelToken && axiosCancelToken.cancel) {
        axiosCancelToken.cancel();
      }
      axiosCancelToken = axios.CancelToken.source();
      dispatch(getDoctors(params, false, axiosCancelToken.token));
    },
    [dispatch],
  );

  return {
    getDoctors: getListDoctor,
    loading: status.loadList === 0,
    doctors: list,
    meta,
  };
};

export default useGetDoctors;
